import { useLocation, useNavigate } from "react-router-dom";
import { useQueryParams } from "@App/hooks/useQueryParams";
import { useEntryPage } from "@App/contexts/EntryPageContext";

export const useNavigateWithQueryParams = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { createQuery } = useQueryParams();
  const { setEntryPage } = useEntryPage();

  const navigateWithQuery = (
    path: string,
    navigateByPath?: boolean,
    query_params?: Record<string, string>,
  ) => {
    // navigateWithQuery has a param, that allows to toggle routing by path (the default is route)
    // With the update apparently navigation by route adds to the current route url, which is why
    // we now navigate relatively to the current path via "../abc"

    // set the Entry-Page to handle the functionality of the back button
    path == "werkstaetten" && setEntryPage(location.pathname + location.search);

    return navigate(path + createQuery(query_params), navigateByPath ? { relative: "path" } : {});
  };

  return { navigateWithQuery };
};
